import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1c71746c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=1c71746c&prod&scoped=scoped&lang=css"
import style1 from "./Index.vue?vue&type=style&index=1&id=1c71746c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c71746c",
  null
  
)

export default component.exports